<template>
  <section class="profile-container">
    <div class="left-cotainer">
      <div class="title">企业信息</div>
      <div class="main">
        <span class="sub">公司编码：</span>
        <span>{{ userInfo.customerCode }}</span>
      </div>
      <div class="main">
        <span class="sub">公司名称：</span>
        <span>{{ userInfo.customerName }}</span>
      </div>
      <div class="main">
        <span class="sub">公司简称：</span>
        <span>{{ userInfo.customerShortName }}</span>
      </div>
      <div class="main">
        <span class="sub">税&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;号：</span>
        <span>{{ userInfo.c_SH }}</span>
      </div>
      <div class="main">
        <span class="sub">联系地址：</span>
        <span>{{ userInfo.c_Address }}</span>
      </div>
      <!-- <div class="main">
        <span class="sub">合作时间：</span>
        <span>{{ userInfo.c_HZNX }}</span>
      </div> -->
      <img class="bottom" src="../../../assets/img/profile_left_bottom.png" />
    </div>
    <div class="right-container">
      <div class="top">
        <div class="top-title">目标</div>
        <div class="top-sub-title">公司</div>
        <el-select
          filterable
          v-model="target_company"
          clearable
          placeholder="请选择"
          class="mr"
          @change="getTargetList"
        >
          <el-option
            v-for="item in companyList"
            :key="item.COMPANY_CODE"
            :label="item.COMPANY_NAME"
            :value="item.COMPANY_CODE"
          >
          </el-option>
        </el-select>
        <div class="top-sub-title">销售类别</div>
        <el-select
          v-model="target_sales"
          clearable
          filterable
          placeholder="请选择"
          @change="getTargetList"
        >
          <el-option
            v-for="item in xslbList"
            :key="item.SALE_CODE"
            :label="item.SALE_NAME"
            :value="item.SALE_CODE"
          >
          </el-option>
        </el-select>
      </div>

      <div class="target-container">
        <div class="target-item">
          <div>当月度目标达成</div>
          <el-progress
            class="progress"
            type="circle"
            :width="100"
            :height="100"
            :percentage="targetList.DYWCL"
            color="#f15f6b"
            stroke-width="5"
            :format="setItemText(targetList.DYWCL)"
          />
          <div class="text">
            目标：<span class="red">{{ targetList.DYMB }}万元</span>
          </div>
          <div class="text">
            实际：<span class="red">{{ targetList.DYSJ }}万元</span>
          </div>
        </div>

        <div class="target-item">
          <div>年度目标累积达成</div>
          <el-progress
            class="progress"
            type="circle"
            :width="100"
            :height="100"
            :percentage="targetList.DNWCL"
            color="#e6a23c"
            stroke-width="5"
            :format="setItemText(targetList.DNWCL)"
          />
          <div class="text">
            目标：<span class="red">{{ targetList.DNMB }}万元</span>
          </div>
          <div class="text">
            实际：<span class="red">{{ targetList.DNSJ }}万元</span>
          </div>
        </div>
      </div>

      <div class="top">
        <div class="top-title">财务</div>
        <div class="top-sub-title">公司</div>
        <el-select
          v-model="caiwu_company"
          clearable
          filterable
          placeholder="请选择"
          class="mr"
          @change="getCaiwuInfo"
        >
          <el-option
            v-for="item in comList"
            :key="item.orgId"
            :label="item.name"
            :value="item.orgId"
          >
          </el-option>
        </el-select>
      </div>

      <div class="caiwu-main">
        <div class="caiwu-line">
          <img class="" src="../../../assets/img/zh1.svg" />
          <div>
            <div>账户余额</div>
            <span>{{ caiwuInfo.ptAccount && caiwuInfo.ptAccount.yue }}</span>
          </div>
        </div>
        <div class="caiwu-line">
          <img class="" src="../../../assets/img/zh2.svg" />
          <div>
            <div>最大欠款天数</div>
            <span>{{
              caiwuInfo.xyAccount && caiwuInfo.xyAccount.maxOutTimeDays
            }}</span>
          </div>
          <div>
            <div>欠款总金额</div>
            <span>{{
              caiwuInfo.xyAccount && caiwuInfo.xyAccount.totalQk
            }}</span>
          </div>
          <div>
            <div>超付款周期欠款金额</div>
            <span>{{
              caiwuInfo.xyAccount && caiwuInfo.xyAccount.outTimeQk
            }}</span>
          </div>
          <div>
            <div>清欠期欠款金额</div>
            <span>{{
              caiwuInfo.xyAccount && caiwuInfo.xyAccount.cleanQk
            }}</span>
          </div>
          <div>
            <div>预警期内欠款金额</div>
            <span>{{
              caiwuInfo.xyAccount && caiwuInfo.xyAccount.warningQk
            }}</span>
          </div>
        </div>
        <div class="caiwu-line">
          <img class="" src="../../../assets/img/zh3.svg" />
          <div>
            <div>罚息未缴纳金额</div>
            <span>{{
              caiwuInfo.xyAccount && caiwuInfo.xyAccount.fxAmount
            }}</span>
          </div>
        </div>
      </div>

      <!-- <div class="top">
        <div class="top-title">物流</div>
        <div class="top-sub-title">公司</div>
        <el-select
          v-model="wuliu_company"
          clearable
          filterable
          placeholder="请选择"
          class="mr"
          @change="getWuliuList"
        >
          <el-option
            v-for="item in companyListforwuliu"
            :key="item.orgId"
            :label="item.name"
            :value="item.orgId"
          >
          </el-option>
        </el-select>
        <div class="top-sub-title">销售类别</div>
        <el-select
        filterable
          v-model="wuliu_type"
          clearable
          placeholder="请选择"
          @change="getWuliuList"
        >
          <el-option
            v-for="item in xslbList"
            :key="item.SALE_NAME"
            :label="item.SALE_NAME"
            :value="item.SALE_NAME"
          >
          </el-option>
        </el-select>
      </div> -->

      <!-- <el-table
        :data="wuliuList"
        border
        stripe
        style="width: 100%; margin-top: 10px"
        max-height="300"
      >
        <el-table-column prop="company" label="公司"> </el-table-column>
        <el-table-column prop="seq" label="订单号"> </el-table-column>
        <el-table-column prop="sellType" label="销售类别"> </el-table-column>
        <el-table-column prop="weight" label="重量"> </el-table-column>
        <el-table-column prop="amount" label="金额"> </el-table-column>
        <el-table-column prop="state" label="订单状态"> </el-table-column>
      </el-table> -->

      <div class="top">
        <div class="top-title">客诉</div>
      </div>

      <el-table
        :data="kesuList"
        border
        stripe
        style="width: 100%; margin-top: 20px"
        max-height="300"
      >
        <el-table-column prop="ROWNO" label="序号"> </el-table-column>
        <el-table-column prop="TP_CODE" label="客诉编号"> </el-table-column>
        <el-table-column prop="CTTIME" label="问题提交时间"> </el-table-column>
        <el-table-column
          prop="STATUS"
          label="状态

"
        >
        </el-table-column>
        <el-table-column prop="TP_THEME" label="主题"> </el-table-column>
        <el-table-column prop="BUSINESSUSER" label="申请人"> </el-table-column>
      </el-table>

      <div class="top">
        <div class="top-title">返还</div>
        <div class="top-sub-title">公司</div>

        <el-select
          v-model="fanhuan_company"
          clearable
          filterable
          placeholder="请选择"
          class="mr"
          @change="getFanhuanList"
        >
          <el-option
            v-for="item in comList"
            :key="item.orgId"
            :label="item.name"
            :value="item.orgId"
          >
          </el-option>
        </el-select>

        <!-- <el-select
          v-model="fanhuan_company"
          clearable
          placeholder="请选择"
          class="mr"
          @change="getFanhuanList"
        >
          <el-option
            v-for="item in companyList"
            :key="item.COMPANY_CODE"
            :label="item.COMPANY_NAME"
            :value="item.COMPANY_CODE"
          >
          </el-option>
        </el-select> -->

        <!-- <el-select
        filterablee 
          v-model="fanhuan_company"
          clearable
          placeholder="请选择"
          class="mr"
          @change="getFanhuanList"
        >
      <el-option
            v-for="item in xslbList"
            :key="item.SALE_CODE"
            :label="item.SALE_NAME"
            :value="item.SALE_CODE"
          >
          </el-option>
        </el-select> -->
        <div class="top-sub-title">销售类别</div>

        <el-select
          v-model="fanhuan_type"
          clearable
          filterable
          placeholder="请选择"
          @change="getFanhuanList"
        >
          <el-option
            v-for="item in xslbListforFanhuan"
            :key="item.TSY_ID"
            :label="item.label"
            :value="item.TSY_ID"
          >
          </el-option>
        </el-select>

        <!-- <el-select v-model="fanhuan_type" clearable placeholder="请选择 "  filterablee      @change="getFanhuanList">
          <el-option
            v-for="item in xslbList"
            :key="item.TSY_ID"
            :label="item.TSY_NAME"
            :value="item.TSY_ID"
    

          >
          </el-option>
        </el-select> -->
      </div>

      <el-table
        :data="fanhuanList"
        border
        style="width: 100%; margin-top: 20px"
        max-height="300"
      >
        <el-table-column prop="LINE_TYPE_NAME" label="销售类别">
        </el-table-column>
        <el-table-column prop="AMOUNT" label="剩余返还金额"> </el-table-column>
      </el-table>
    </div>
  </section>
</template>



<script>
import { onMounted, setup, ref, getCurrentInstance } from "vue";

export default {
  //目标用的是一个公司接口
  //物流 财务  返还用的是一个公司接口
  setup() {
    let { proxy } = getCurrentInstance();

    let target_class = ref(""); //销售目标绑定的类别
    
    let setItemText = (row) => {
      return () => {
        if (row) {
          return "完成率 " + "\n" + row + "%";
        }
      };
    };

    //下拉 公司列表
    let companyList = ref([]);
    let getCompanyList = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxSalesTargetsDropDown", {
          postType: "companyQuery",
        })
        .then((res) => {
          companyList.value = res.items;
          target_company.value = res.items[0].COMPANY_CODE; //默认目标的第一个公司
        });
    };

    //物流 和 财务   的下拉 公司列表
    let companyListforwuliu = ref([]);
    let getCompanyListforwuliu = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxOrderInfo", {
          postType: "queryInvoice",
        })
        .then((res) => {
          companyListforwuliu.value = res.data;
          wuliu_company.value = res.data[0].orgId; //物流默认公司
          // caiwu_company.value=res.data[0].orgId  //财务默认公司
          fanhuan_company.value = res.data[0].orgId; //返还默认公司
        });
    };

    let companyListforcaiwu = ref([]);
    let getcompanyListforcaiwu = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxOrderInfo", {
          postType: "queryDrawCwCompany",
        })
        .then((res) => {
          companyListforcaiwu.value = res.data;
          //  caiwu_company.value=res.data[0].id  //财务默认公司
        });
    };


//财务和返还的下拉公司列表
let comList=ref([])
let getComList=()=>{
     proxy.$axios
        .postReq("/meide/REST/ajaxOrderList", {
          postType: "queryDrawInvoice",
        })
        .then((res) => {
          comList.value = res.data;
          //  caiwu_company.value=res.data[0].id  //财务默认公司
        });
}




    //下拉 销售类别接口
    let xslbList = ref([]);
    let getXslbList = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxSalesTargetsDropDown", {
          postType: "salesType",
        })
        .then((res) => {
          xslbList.value = res.items;
        });
    };

    // 获取用户基本信息
    let userInfo = ref({});
    let getUserInfo = () => {
      let datauser = {
        postType: "queryInfo",
        customerId: JSON.parse(localStorage.getItem("userInfo")).customerCode,
      };
      proxy.$axios
        .postReq("/meide/REST/QueryUserIdInfo", datauser)
        .then((res) => {
          userInfo.value = res.data;
        });
    };

    //目标接口
    let targetList = ref({}); //目标data
    let target_company = ref(""); //公司编码添加
    let target_sales = ref(""); //销售类别条件
    let getTargetList = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxSalesPortrayal", {
          // cusCode: "CN310001",
          cusCode: JSON.parse(localStorage.getItem("userInfo")).customerCode,
          postType: "cusTarget",
          companyCode: target_company.value, //公司编码
          salesCode: target_sales.value, //销售类别编码
        })
        .then((res) => {
          if (res.items.length > 0) {
            targetList.value = res.items[0];
          } else {
            proxy.$alert("此类别下暂无数据", "提示");
          }
        });
    };

    //获取客户财务查询列表接口
    let caiwuInfo = ref({});
    let caiwu_company = ref("");
    let getCaiwuInfo = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxOrderInfo", {
          postType: "queryPayType",
          orgId: caiwu_company.value, //公司编码

          fxs: "",
        })
        .then((res) => {
          caiwuInfo.value = res.data;
        });

      // proxy.$axios
      //   .postReq("/meide/REST/CustomerPortarit", {
      //     postType: "customerFinanceDetail",
      //     groupId: caiwu_company.value, //公司编码
      //   })
      //   .then((res) => {
      //     caiwuInfo.value = res.data;
      //   });
    };

    //获取物流列表

    let wuliuList = ref([]);
    let wuliu_company = ref("");
    let wuliu_type = ref("");
    let getWuliuList = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxOrderList", {
          postType: "cusDrawWl",
          fxs: wuliu_company.value,
          sellType: wuliu_type.value,
        })
        .then((res) => {
          wuliuList.value = res.data;
        });
    };

    //客诉列表
    let kesuList = ref([]);
    let getKesuList = () => {
      proxy.$axios
        .postReq("/meide/REST/ProblemClose", {
          postType: "Search",
          source: "customer",
          type: "TS",
          PageStart: 1,
          PageLimit: 10,
          stage: "XQ",
        })
        .then((res) => {
          kesuList.value = res.items;
        });
    };

    //返还列表
    let fanhuanList = ref([]);
    let fanhuan_company = ref("");
    let fanhuan_type = ref("");
    let getFanhuanList = () => {
      proxy.$axios
        .postReq("/meide/REST/CustomerPortarit", {
          postType: "customerReturn",
          groupId: fanhuan_company.value, //公司id
          lineTypeName: fanhuan_type.value, //销售类别
        })
        .then((res) => {
          fanhuanList.value = res.data;
        });
    };

    let xslbListforFanhuan = ref([]);
    let getXslbListforFanhuan = () => {
      proxy.$axios
        .postReq("/meide/REST/ajaxMdIndex", {
          postType: "queryxslb",
        })
        .then((res) => {
          let data = res.items;
          data.map((item) => {
            item.label = item.TSY_ID + "-" + item.TSY_NAME;
          });
          xslbListforFanhuan.value = data;
        });
    };
    onMounted(() => {
      // proxy.$axios
      //   .postReq("/meide/REST/ajaxMdIndex", {
      //     postType: "queryxslb",
      //   })
      //   .then((res) => {
      //     console.log(res, '------老的销售类别接口----');
      //   });
      getcompanyListforcaiwu(); //财务公司列表
      getCompanyList(); //公司列表接口
      getXslbList(); //销售类别接口
      getTargetList(); //目标接口
      getCaiwuInfo(); //财务信息接口
      getUserInfo(); //获取用户信息
      getWuliuList(); //物流接口
      getKesuList(); //客诉列表
      getFanhuanList(); //返还列表
      getCompanyListforwuliu(); //物流的公司接口
      getXslbListforFanhuan(); //返还的销售类别接口
      getComList()//财务和返还的下拉公司
    });
    return {
      comList,
      caiwuInfo,
      companyList,
      xslbList,
      target_company,
      target_sales,
      setItemText,
      wuliuList,
      kesuList,
      fanhuanList,
      targetList,
      userInfo,
      getTargetList,
      caiwu_company,
      getCaiwuInfo,
      fanhuan_type,
      fanhuan_company,
      getFanhuanList,
      wuliu_company,
      getWuliuList,
      wuliu_type,
      companyListforwuliu,
      xslbListforFanhuan,
      companyListforcaiwu,
    };
  },
};
</script>

<style lang="scss" scoped>
.left-cotainer {
  position: relative;
  border-width: 0px;
  //   position:absolute;
  left: 0px;
  top: 0px;
  width: 358px;
  height: 376px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  border: none;
  border-bottom: 0px;
  border-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: 5px 5px 21px rgba(0, 0, 0, 0.137254901960784);
  -webkit-box-shadow: 5px 5px 21px rgba(0, 0, 0, 0.137254901960784);
  box-shadow: 5px 5px 21px rgba(0, 0, 0, 0.137254901960784);
  box-sizing: border-box;
  padding: 40px 20px;
  .title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .main {
    margin: 10px 0;
    span {
      font-size: 12px;
    }
    .sub {
      font-weight: 700;
    }
  }
  .bottom {
    width: 359px;
    height: 49px;
    position: absolute;
    left: 0;
    bottom: 20px;
  }
}

.profile-container {
  display: flex;
}
.right-container {
  border-width: 0px;

  width: 820px;
  // height: 1959px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  -moz-box-shadow: 5px 5px 21px rgba(0, 0, 0, 0.137254901960784);
  -webkit-box-shadow: 5px 5px 21px rgba(0, 0, 0, 0.137254901960784);
  box-shadow: 5px 5px 21px rgba(0, 0, 0, 0.137254901960784);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 12px;
  margin-left: 30px;
}
.top {
  box-sizing: border-box;
  padding: 20px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  .top-title {
    margin-right: 20px;
    font-size: 16px !important;
    font-weight: 650 !important;
  }
  .top-sub-title {
    margin-right: 15px;
    font-size: 16px !important;
  }
  .mr {
    margin-right: 20px;
  }
}
// 进度条文字换行
::v-deep(.el-progress__text) {
  line-height: 1.5;
  font-weight: 700;
  white-space: pre-wrap;
}
.target-container {
  display: flex;
  align-items: center;
  .target-item {
    padding: 25px;
    margin-right: 20px;
  }
  .progress {
    margin: 15px auto;
  }
  .text {
    font-size: 12px;
    margin-bottom: 5px;
  }
}
.red {
  color: #f42434;
  font-size: 12px;
}
.caiwu-main {
  padding: 40px;
  box-sizing: border-box;
}
.caiwu-line {
  margin-bottom: 20px;
  img {
    height: 30px;
    width: 30px;
    margin-right: 30px;
  }
  display: flex;
  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 20px;

    > div {
      font-weight: bold;
      font-size: 12px;
    }
    > span {
      font-size: 12px;
    }
  }
}
</style>